import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { getOwner } from '../Api'

export default generateApiAction({
  baseType: Types.OWNERS.GET,
  api: getOwner,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/owners/GetAction.js